import { createAction } from "redux-starter-kit";
import { OPEN_CREATE_DEBTOR } from "../../types";

export default () => createAction(OPEN_CREATE_DEBTOR)();
